import {READ_MORE_CUT_OFF_LENGTH} from '../../constants/appConstants';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import {useState} from 'react';
import CardContent from '@mui/material/CardContent';
import {Link} from 'react-router-dom';
import {getHashtagLink} from '../../utils/helper';
import Stack from '@mui/material/Stack';

export default function Description({description, hashtags = ['tag1', 'tag2']}) {
  const [isReadMoreExpanded, setIsReadMoreExpanded] = useState(false)

  if (!description) {
    return null
  }

  const renderHastags = () => {
    return <Stack
      direction="row"
      sx={{mt: 1, overflow: 'auto'}}
      spacing={1}
    >
      <>Tags: {' '}</>

      {hashtags.map(hashtag => (<><Link to={getHashtagLink(hashtag)}>#{hashtag}</Link>, </>))}
    </Stack>
  }

  if (description.length < READ_MORE_CUT_OFF_LENGTH) {
    return <CardContent><Typography>
      {description}
    </Typography>
    </CardContent>
  }
  return <CardContent><Typography>
    {description.substring(0, READ_MORE_CUT_OFF_LENGTH)} ...

    <>{isReadMoreExpanded
      ? description.substring(READ_MORE_CUT_OFF_LENGTH, 10000)
      : <a href="#" onClick={(e) => {
        e.preventDefault();
        setIsReadMoreExpanded(true)
      }}>
        {'Show more'}
      </a>
    }</>
  </Typography>
    {renderHastags()}
  </CardContent>
}
